import React from "react";
import { t, businessName, itemName, customerMobile } from "./invoiceTemplate.shared";
import { InvoiceBrandMark, InvoiceSignature } from "./InvoiceBrandAssets";
import "./MinimalInvoiceTemplate.css";

const MinimalInvoiceTemplate = ({
  invoice,
  invoiceNumber,
  businessSnapshot,
  customerName,
  customerSnapshot,
  billingAddress,
  shippingAddress,
  calculatedItems = [],
  totals = {},
  grandTotal = 0,
  paidAmount = 0,
  balanceAmount = 0,
  displayCurrency,
  formatAddress,
  formatDate,
  formatLabel,
  formatNumber,
  numberToWords,
}) => (
  <section className="invoice-minimal">
    <header><div className="invoice-template-brand-block"><InvoiceBrandMark businessSnapshot={businessSnapshot} /><div><h1>{businessName(businessSnapshot)}</h1><p>{formatAddress(businessSnapshot?.address || businessSnapshot)}</p></div></div><aside><small>INVOICE</small><b>{invoiceNumber}</b><span>{formatDate(invoice?.documentDate)}</span></aside></header>
    <div className="invoice-minimal__line"/>
    <div className="invoice-minimal__party"><div><small>BILLED TO</small><b>{customerName}</b><p>{formatAddress(billingAddress)}</p></div><div><small>CONTACT</small><b>{customerMobile(customerSnapshot, invoice)}</b><p>GSTIN: {t(customerSnapshot?.gstin)}</p></div></div>
    <table><thead><tr><th>Description</th><th>Qty</th><th>Rate</th><th>Tax</th><th>Amount</th></tr></thead><tbody>{calculatedItems.map((item,index)=><tr key={item?._id || index}><td><b>{itemName(item)}</b><small>{item?.description || ""}</small></td><td>{formatNumber(item?.calculation?.quantity,0,2)}</td><td>{displayCurrency(item?.calculation?.rate)}</td><td>{formatNumber(item?.taxPercentage,0,2)}%</td><td>{displayCurrency(item?.calculation?.totalAmount)}</td></tr>)}</tbody></table>
    <div className="invoice-minimal__bottom"><div><small>AMOUNT IN WORDS</small><b>Indian Rupees {numberToWords(grandTotal)} Only</b><p>{invoice?.customerNotes || "Thank you for your business."}</p></div><aside><span>Subtotal <b>{displayCurrency(totals?.subtotal ?? totals?.grossAmount ?? 0)}</b></span><span className="grand">Total <b>{displayCurrency(grandTotal)}</b></span><span>Paid <b>{displayCurrency(paidAmount)}</b></span><span>Balance <b>{displayCurrency(balanceAmount)}</b></span></aside></div>
    <footer><span>GSTIN: {t(businessSnapshot?.gstin)}</span><span>{t(businessSnapshot?.mobile)}</span><InvoiceSignature businessSnapshot={businessSnapshot} /></footer>
  </section>
);

export default MinimalInvoiceTemplate;
